module.exports = __webpack_public_path__ + "img/1.aeb08b4a.jpg";